import React from "react";
import banner from "../../assets/12_Quienes somos/Astara/Asset.png";

/*eslint-disable */

declare const window: any;
const BannerComponent: React.FC = () => {
  return (
    <div className="banner-astara-component">
      <img 
        {...({ fetchpriority: "high" } as any)} 
        loading="eager" 
        src={banner} 
        alt="Banner de Astara, empresa global de movilidad sostenible" 
      />
    </div>
  );
};

export default BannerComponent;
